import { render, staticRenderFns } from "./org_modal.vue?vue&type=template&id=2273faa0&scoped=true&"
import script from "./org_modal.vue?vue&type=script&lang=js&"
export * from "./org_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273faa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2273faa0')) {
      api.createRecord('2273faa0', component.options)
    } else {
      api.reload('2273faa0', component.options)
    }
    module.hot.accept("./org_modal.vue?vue&type=template&id=2273faa0&scoped=true&", function () {
      api.rerender('2273faa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/org_modal.vue"
export default component.exports